var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomCaption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.08,
    height: 23.326,
    viewBox: "0 0 28.08 23.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "custom-caption",
    transform: "translate(-738.153 -1023.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(738.153 1023.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M762.138,1047.307H742.248a4.1,4.1,0,0,1-4.095-4.1v-15.133a4.1,4.1,0,0,1,4.095-4.1h19.891a4.1,4.1,0,0,1,4.095,4.1v15.133A4.1,4.1,0,0,1,762.138,1047.307Zm-19.891-20.852a1.626,1.626,0,0,0-1.622,1.624v15.133a1.623,1.623,0,0,0,1.622,1.622h19.891a1.623,1.623,0,0,0,1.622-1.622v-15.133a1.625,1.625,0,0,0-1.622-1.624Z",
    transform: "translate(-738.153 -1023.981)",
    fill: "#307ad7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(744.205 1031.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M757.3,1031.687H743.794a1.237,1.237,0,0,1,0-2.474H757.3a1.237,1.237,0,0,1,0,2.474Z",
    transform: "translate(-742.559 -1029.213)",
    fill: "#307ad7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(0 6.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M752.527,1036.4h-8.733a1.236,1.236,0,0,1,0-2.472h8.733a1.236,1.236,0,1,1,0,2.472Z",
    transform: "translate(-742.559 -1033.932)",
    fill: "#307ad7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCaption);
export default __webpack_public_path__ + "static/media/custom-caption.4f3c02550e35d570da46ae2a1fff3ff7.svg";
export { ForwardRef as ReactComponent };